import * as React from 'react';
import S from './DotPagination.styles';
const DotPagination = ({ ariaLabel, count, value, onChange, excludeFill = false, }) => {
    const dotWidth = `${100 / count}%`;
    return (React.createElement(S.Container, { "aria-label": ariaLabel, "data-exclude-fill": excludeFill, style: { '--width': dotWidth, '--fill': `${(value + 1) / count}` } },
        React.createElement(S.Fill, null),
        Array.from(Array(count)).map((_, index) => (React.createElement(S.Item, { key: `DotPaginationItem_${index}`, "aria-current": index === value, "aria-label": `Go to ${index + 1}`, onClick: (event) => {
                event.preventDefault();
                onChange(index);
            }, "data-passed": index <= value })))));
};
export default DotPagination;
